var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 22,
    viewBox: "0 0 50 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4753 11.099C7.01227 5.10325 0.04866 0.153192 0.000155181 0.0988334C-0.0481388 0.0444752 11.182 0 24.9561 0H50L49.2366 1.59961C48.8167 2.47923 48.1199 3.92837 47.6882 4.81984L46.9033 6.44046L35.0989 6.42835C25.0211 6.41797 23.34 6.4664 23.6064 6.75895C23.7783 6.94772 25.729 8.45048 27.9415 10.0988L31.9642 13.0954H34.6372C36.1074 13.0954 37.3103 13.0082 37.3103 12.9017C37.3103 12.7952 36.398 11.878 35.283 10.8632L33.2555 9.01852L36.3244 8.95033C38.0121 8.91277 40.8144 8.91277 42.5515 8.95033L45.7101 9.01852L42.6152 15.4427L39.5204 21.8668L35.1913 21.9335L30.8623 22L15.4753 11.099Z",
    fill: "#355DEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFig);
export default __webpack_public_path__ + "static/media/logo_fig.1fed35e506245ecd756163aab96da586.svg";
export { ForwardRef as ReactComponent };